// extracted by mini-css-extract-plugin
export default {"select":"select__f49j3"};